var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorRebranded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.665,
    height: 20.665,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 241",
    d: "M10.333 0a10.333 10.333 0 1010.332 10.333A10.327 10.327 0 0010.333 0zm0 19.051a8.718 8.718 0 118.718-8.718 8.713 8.713 0 01-8.718 8.718z",
    fill: "#EC008B"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 242",
    d: "M10.332 5.202a.807.807 0 00-.807.807v5.2a.807.807 0 101.614 0v-5.2a.807.807 0 00-.807-.807z",
    fill: "#EC008B"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 25",
    cx: 1.09,
    cy: 1.09,
    fill: "#EC008B",
    r: 1.09,
    transform: "translate(9.243 13.003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRebranded);
export default __webpack_public_path__ + "static/media/error-rebranded.e9ada01ed0bb94cf7ab5665c7e492188.svg";
export { ForwardRef as ReactComponent };